import { createSlice } from '@reduxjs/toolkit';
import { WeightUnit } from '../types/weightUnit';
import { Pagination } from '../types/pagination';
import type { PayloadAction } from '@reduxjs/toolkit';
import { getWeightUnitsApi, createWeightUnitsApi, updateWeightUnitsApi } from '../services/weightUnits/weightUnits';
import { setAlert } from './commonSlice';
import { createQuery } from '../utils/constants';

interface InitialState {
  weightUnits: WeightUnit[];
  filter: Filter;
  loader: boolean;
  saveLoader: boolean;
  selectedWeightUnit: WeightUnit | null;
}

interface Filter {}

const initialState: InitialState = {
  weightUnits: [],
  filter: {},
  loader: false,
  saveLoader: false,
  selectedWeightUnit: null,
};

export const weightUnitSlice = createSlice({
  name: 'weightUnit',
  initialState,
  reducers: {
    getProductWeightUnits: (state, action: PayloadAction<any>) => {
      state.weightUnits = action.payload.manufacturers;
    },
    setWeightUnits: (state, action: PayloadAction<any>) => {
      state.weightUnits = action.payload;
    },
    setFilter: (state, action: PayloadAction<any>) => {
      state.filter = action.payload;
    },
    setLoader: (state, action: PayloadAction<any>) => {
      state.loader = action.payload;
    },
    setSaveLoader: (state, action: PayloadAction<any>) => {
      state.saveLoader = action.payload;
    },
    setWeightUnit: (state, action: PayloadAction<any>) => {
      state.selectedWeightUnit = action.payload;
    },
  },
});

export const { getProductWeightUnits, setWeightUnits, setFilter, setLoader, setSaveLoader, setWeightUnit } =
  weightUnitSlice.actions;
export default weightUnitSlice.reducer;

export const getWeightUnits = (payload: any) => async (dispatch: any, getState: any) => {
  try {
    dispatch(setLoader(true));
    const { filter } = getState().weightUnit;
    const queryParams = { ...filter, ...payload };
    const query = '?' + createQuery({ filter: queryParams });

    const response = await getWeightUnitsApi(query);
    if (response.kind === 'ok') {
      const { pagination, data: list } = response.data;

      dispatch(setWeightUnits(list));
    }
  } catch (error) {
  } finally {
    dispatch(setLoader(false));
  }
};

export const getWeightUnit = (payload: WeightUnit | null) => async (dispatch: any, getState: any) => {
  dispatch(setWeightUnit(payload));
};

export const creatWeightUnit = (payload: any, cb?: any) => async (dispatch: any) => {
  try {
    dispatch(setSaveLoader(true));
    const result = await createWeightUnitsApi(payload);
    if (result?.kind === 'ok') {
      dispatch(setAlert('Weight unit has been created successfully', 'success'));
      cb?.(null, true);
    } else {
      /*Toast.show({
        type: 'error',
        text1: 'Failed',
        text2: 'Failed to create address',
      });*/
    }
  } catch (err) {
  } finally {
    dispatch(setSaveLoader(false));
  }
};

export const updateWeightUnit = (weightUnitId: any, payload: any, cb?: any) => async (dispatch: any) => {
  try {
    dispatch(setSaveLoader(true));
    const result = await updateWeightUnitsApi(weightUnitId, payload);
    if (result?.kind === 'ok') {
      dispatch(setAlert('Weight unit has been updated successfully', 'success'));
      cb?.(null, true);
    } else {
      /*Toast.show({
        type: 'error',
        text1: 'Failed',
        text2: 'Failed to create address',
      });*/
    }
  } catch (err) {
  } finally {
    dispatch(setSaveLoader(false));
  }
};

export const applyFilter = (payload: any) => async (dispatch: any, getState: any) => {
  return dispatch(setFilter(payload));
};
